// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductTraining_containers {
  overflow: hidden;
  height: 100vh;
}
.ProductTraining_containers .ProductTraining_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.ProductTraining_containers .sidebar {
  width: 20%;
  background: #dde7f5;
}
.ProductTraining_containers .ProductTrainingcontent {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 84vh;
}
.ProductTraining_containers .thumbnaiils-produt {
  width: 23px !important;
  height: 15px !important;
}
.ProductTraining_containers .checkbox_contain {
  width: 100%;
  display: flex;
  align-items: center;
}
.ProductTraining_containers .checkbox_label {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgb(16, 19, 46);
}
.ProductTraining_containers .checkbox_labelactive {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgb(12, 54, 136);
}
.ProductTraining_containers .checkbox_container {
  display: flex;
  width: 20%;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .checkbox_containerTutorial {
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .checkbox_containerTrouble {
  display: flex;
  width: 40%;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .input_checkbox {
  width: 18px;
  height: 18px;
  margin: 0.5rem;
  border-radius: 1rem;
  background: rgb(0, 0, 0);
}
.ProductTraining_containers .input_checkbox:checked {
  background: rgb(12, 54, 136) !important;
  color: white;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons {
  display: flex;
  width: 95%;
  margin: 1rem;
  justify-content: space-between;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial {
  width: auto;
  padding: 10px;
  left: 299px;
  top: 122px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #FFFFFF;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .training_module {
  display: flex;
  gap: 10px;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial_TutorialShooting {
  width: auto;
  padding: 10px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  border: none;
  color: #FFFFFF;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_TutorialShooting {
  width: 16%;
  height: 40px;
  background: #0C3688;
  border-radius: 8px 8px 8px 8px;
  color: white;
  border: none;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Modules {
  width: auto;
  padding: 10px;
  background: #E5F0FF;
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: rgb(12, 54, 136);
  border: none;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_ModulesTutorialShooting {
  width: auto;
  padding: 10px;
  background: #E5F0FF;
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: rgb(12, 54, 136);
  border: none;
}
.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_AddTutorial {
  width: auto;
  padding: 10px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  border: none;
  font-family: "Poppins";
  font-style: normal;
}
.ProductTraining_containers .pgmlist_buttons {
  display: flex;
  width: 96%;
  margin: 1rem;
  gap: 1rem;
  border-bottom: 1px solid #C1C6D0;
}
.ProductTraining_containers .dealers_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #10132e;
}
.ProductTraining_containers .dealers_button {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  border: none;
  height: 2.5rem;
  cursor: pointer;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .Pgmlist_pending {
  width: 15%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0C3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #FFFFFF;
}
.ProductTraining_containers .pgmlist_Approved {
  width: 15%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7C87A1;
  border: none;
}
.ProductTraining_containers .pgmlist_Add {
  width: 15%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7C87A1;
  border: none;
}
.ProductTraining_containers .input-wrapper {
  position: relative;
}
.ProductTraining_containers .input_search {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.5rem;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.ProductTraining_containers label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.ProductTraining_containers .partscatainersorders {
  display: flex;
  margin: 1rem;
  width: 100%;
  gap: 2.4rem;
}
.ProductTraining_containers .partscatainersorders_s {
  display: flex;
}
.ProductTraining_containers .AddpartsbulkAddpartsbulk {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}
.ProductTraining_containers .AddpartsbulkAddpartsbulk_s {
  background: #E4ECF7;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  border: none;
  border-radius: 5px;
  color: #0C3688;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}
.ProductTraining_containers .select-wrapper {
  position: relative;
  display: block;
}
.ProductTraining_containers select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.ProductTraining_containers ::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.ProductTraining_containers .productTrainingdropdown_textfield {
  display: flex;
  justify-content: space-between;
  width: 96%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem;
}
.ProductTraining_containers .productTrainingPanel_checkbox {
  display: flex;
  justify-content: space-between;
  width: 96%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 0px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  /* border-radius: 6px; */
  margin: 0rem 1rem 0rem 1rem;
  padding: 0.6rem;
  position: relative;
  /* bottom: -1rem; */
  top: 1rem;
}
.ProductTraining_containers .btn_search_module {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 20%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}
.ProductTraining_containers .btn_search_module:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.ProductTraining_containers .button_search {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 40%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}
.ProductTraining_containers .button_search:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.ProductTraining_containers .button_div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .tabledata-product {
  display: flex;
  width: 96%;
  margin: 1rem 1rem;
  overflow: auto;
}
.ProductTraining_containers .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
  overflow: auto;
}
.ProductTraining_containers .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.ProductTraining_containers .tabletd {
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
  width: 18%;
  white-space: break-spaces !important;
  word-break: break-all;
}
.ProductTraining_containers .tabletddesc {
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
  word-wrap: break-word !important;
}
.ProductTraining_containers .truncated-description {
  max-width: 8rem !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-wrap: break-word !important;
}
.ProductTraining_containers .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.ProductTraining_containers .footer_div {
  margin-top: 2rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.ProductTraining_containers .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
}
.ProductTraining_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.ProductTraining_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.ProductTraining_containers .productTrainingdropdown_div {
  width: 100%;
}
.ProductTraining_containers .productTrainingdropdown_module {
  width: 32%;
}
.ProductTraining_containers .productTrainingdropdown_search {
  width: 70%;
}
.ProductTraining_containers .footer-panel {
  height: 40px;
  background-color: rgb(229, 240, 255);
  display: flex;
  width: 96%;
  margin: 1rem;
  justify-content: center;
  align-items: center;
}
.ProductTraining_containers .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 782px !important;
}
.ProductTraining_containers .pdf-text {
  font-size: 12px;
  font-weight: 400;
  font-family: "Nunito";
  margin: 0px;
  padding: 3px;
}

@media screen and (max-width: 480px) {
  .ProductTraining_containers .ProductTraining_container {
    width: 100%;
    display: flex;
    overflow: hidden;
    flex-direction: column;
  }
  .ProductTraining_containers .ProductTrainingcontent {
    width: 100%;
    background: #ffffff;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 84vh;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons {
    display: flex;
    width: 95%;
    margin: 1rem;
    gap: 1rem;
    flex-wrap: wrap;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_ModulesTutorialShooting {
    width: auto;
    height: 40px;
    background: #E5F0FF;
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    color: rgb(12, 54, 136);
    border: none;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial {
    /* width: 15%; */
    height: 40px;
    left: 299px;
    top: 122px;
    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    border: none;
    color: #FFFFFF;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial {
    width: auto !important;
    height: 40px;
    left: 299px;
    top: 122px;
    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    border: none;
    color: #FFFFFF;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_AddTutorial {
    width: auto;
    height: 40px;
    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    color: #FFFFFF;
    border: none;
    font-family: "Poppins";
    font-style: normal;
    margin-left: 45%;
  }
  .ProductTraining_containers .productTrainingdropdown_textfield {
    display: flex;
    justify-content: space-between;
    width: 96%;
    background: #ffffff;
    border: 1px solid #c1c6d0;
    border-radius: 6px;
    background: #ffffff;
    border: 1px solid #c1c6d0;
    border-radius: 6px;
    margin: 1rem;
    padding: 0.6rem;
    flex-wrap: wrap;
  }
  .ProductTraining_containers .input_search {
    border: 1px solid gray;
    border-radius: 6px;
    position: relative;
    width: 64%;
    height: 2.3rem;
    margin: 10px;
    line-height: 6ex;
    font-family: "Nunito";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #10132E;
    padding: 0rem 0.5rem;
  }
  .ProductTraining_containers .productTrainingdropdown_module {
    width: 68%;
  }
  .tabledata {
    overflow-x: scroll !important;
  }
  .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial_TutorialShooting {
    width: auto !important;
    height: 40px;
    left: 299px;
    top: 122px;
    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    border: none;
    color: #FFFFFF;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Modules {
    width: auto !important;
    height: 40px;
    background: #E5F0FF;
    border-radius: 8px 8px 8px 8px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    color: rgb(12, 54, 136);
    border: none;
  }
  .ProductTraining_containers .productTrainingPanel_checkbox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 96%;
    background: #ffffff;
    border: 1px solid #c1c6d0;
    border-radius: 0px;
    background: #ffffff;
    border: 1px solid #c1c6d0;
    margin: 0rem 1rem 0rem 1rem;
    padding: 0.6rem;
    position: relative;
    top: 1rem;
  }
  .ProductTraining_containers .tabledata-product {
    display: flex;
    width: 96%;
    margin: 1rem 1rem;
    overflow-x: scroll;
  }
}
@media screen and (max-width: 480px) {
  .ProductTraining_AddTutorial {
    margin-left: 0 !important;
  }
}
@media screen and (max-width: 768px) {
  .ProductTraining_container {
    flex-direction: column;
  }
  .ProductTrainingcontent {
    width: 100% !important;
  }
  .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_ModulesTutorialShooting {
    font-size: 12px;
  }
  .ProductTraining_containers label {
    font-size: 12px;
  }
}
@media screen and (min-width: 481px) and (max-width: 1100px) {
  .ProductTraining_Tutorial_TutorialShooting {
    font-size: 11px !important;
  }
  .ProductTraining_Modules {
    font-size: 11px !important;
  }
  .ProductTraining_AddTutorial {
    font-size: 11px !important;
  }
}
@media screen and (min-width: 481px) and (max-width: 1024px) {
  .ProductTraining_containers .checkbox_contain {
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProductTraining/productTraining.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAGI;EACI,UAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAFR;AAKA;EACI,sBAAA;EACA,uBAAA;AAHJ;AAKI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAJR;AAMI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAJR;AAOI;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AALR;AAQI;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AANR;AASI;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AAPR;AAUI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;AARR;AAWI;EACI,uCAAA;EACA,YAAA;AATR;AAcQ;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;AAZZ;AAcY;EACI,WAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAZhB;AAeY;EACI,aAAA;EACA,SAAA;AAbhB;AAgBY;EACI,WAAA;EACA,aAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAdhB;AAiBY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAfhB;AAkBY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AAhBhB;AAmBY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AAjBhB;AAoBY;EACI,WAAA;EACA,aAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAlBhB;AAuBI;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AArBR;AAyBI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAvBR;AA2BI;EACI,mEAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzBR;AA4BI;EACI,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AA1BR;AA6BI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA3BR;AA8BI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA5BR;AAgCI;EACI,kBAAA;AA9BR;AAiCI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AA/BR;AAkCI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAhCR;AAmCI;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAjCR;AAoCI;EACI,aAAA;AAlCR;AAuCI;EACI,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AArCR;AAyCI;EACI,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAvCR;AA0CI;EACI,kBAAA;EACA,cAAA;AAxCR;AA2CI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAzCR;AA4CI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AA1CR;AA6CI;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA3CR;AA8CI;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AA5CR;AA+CI;EACI,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AA7CR;AAgDI;EACI,mEAAA;AA9CR;AAiDI;EACI,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AA/CR;AAkDI;EACI,mEAAA;AAhDR;AAmDI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjDR;AAoDI;EACI,aAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAlDR;AAqDI;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;AAnDR;AAsDI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AApDR;AAuDI;EACI,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,UAAA;EACA,oCAAA;EACA,qBAAA;AArDR;AAuDI;EACI,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;AArDR;AAuDI;EACI,0BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,gCAAA;AArDR;AAuDI;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AArDR;AAyDI;EACI,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAvDR;AA0DI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAxDR;AA2DI;EACI,mBAAA;AAzDR;AA4DI;EAEI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA3DR;AA8DI;EACI,WAAA;AA5DR;AA8DI;EACI,UAAA;AA5DR;AA8DI;EACI,UAAA;AA5DR;AA+DI;EACI,YAAA;EACA,oCAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA7DR;AAiEI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA/DR;AAkEI;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAhER;;AAoEA;EACI;IACI,WAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;EAjEN;EAmEE;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;EAjEN;EAmEE;IACI,aAAA;IACA,UAAA;IACA,YAAA;IACA,SAAA;IACA,eAAA;EAjEN;EAmEE;IACI,WAAA;IACA,YAAA;IACA,mBAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,uBAAA;IACA,YAAA;EAjEN;EAmEE;IACI,gBAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,mEAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;EAjEN;EAkEG;IACI,sBAAA;IACD,YAAA;IACA,WAAA;IACA,UAAA;IACA,mEAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;EAhEN;EAkEE;IACI,WAAA;IACA,YAAA;IACA,mEAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;EAhEN;EAkEE;IACI,aAAA;IACA,8BAAA;IACA,UAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAhEN;EAkEE;IACI,sBAAA;IACA,kBAAA;IACA,kBAAA;IACA,UAAA;IACA,cAAA;IACA,YAAA;IACA,gBAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;IACA,oBAAA;EAhEN;EAkEE;IACI,UAAA;EAhEN;EAkEE;IACI,6BAAA;EAhEN;EAkEE;IACI,sBAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;IACA,mEAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;EAhEN;EAkEE;IACI,sBAAA;IACA,YAAA;IACA,mBAAA;IACA,8BAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,uBAAA;IACA,YAAA;EAhEN;EAkEE;IACI,aAAA;IACA,eAAA;IACA,8BAAA;IACA,UAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,yBAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;EAhEN;EAkEE;IACA,aAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;EAhEF;AACF;AAmEA;EACI;IACI,yBAAA;EAjEN;AACF;AAoEA;EACI;IACI,sBAAA;EAlEN;EAoEE;IACI,sBAAA;EAlEN;EAoEE;IACI,eAAA;EAlEN;EAoEE;IACI,eAAA;EAlEN;AACF;AAqEA;EACI;IACI,0BAAA;EAnEN;EAqEE;IACI,0BAAA;EAnEN;EAqEE;IACI,0BAAA;EAnEN;AACF;AAsEA;EACI;IACI,SAAA;EApEN;AACF","sourcesContent":[".ProductTraining_containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .ProductTraining_container {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n\n    .sidebar {\n        width: 20%;\n        background: #dde7f5;\n    }\n\n    .ProductTrainingcontent {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 84vh;\n\n    }\n.thumbnaiils-produt{\n    width: 23px !important;\n    height: 15px !important;\n}\n    .checkbox_contain {\n        width: 100%;\n        display: flex;\n        align-items: center;\n    }\n\n    .checkbox_label {\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: rgba(16, 19, 46, 1);\n    }\n    .checkbox_labelactive {\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: rgba(12, 54, 136, 1);\n    }\n\n    .checkbox_container {\n        display: flex;\n        width: 20%;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .checkbox_containerTutorial {\n        display: flex;\n        width: 25%;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .checkbox_containerTrouble {\n        display: flex;\n        width: 40%;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .input_checkbox {\n        width: 18px;\n        height: 18px;\n        margin: 0.5rem;\n        border-radius: 1rem;\n        background: rgba(0, 0, 0, 1);\n    }\n\n    .input_checkbox:checked {\n        background: rgba(12, 54, 136, 1) !important;\n        color: white;\n    }\n    \n\n    .ProductTraining_buttons_container {\n        .ProductTraining_buttons {\n            display: flex;\n            width: 95%;\n            margin: 1rem;\n            justify-content: space-between;\n\n            .ProductTraining_Tutorial {\n                width: auto;\n                padding: 10px;\n                left: 299px;\n                top: 122px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 600;\n                font-size: 15px;\n                border: none;\n                color: #FFFFFF;\n            }\n\n            .training_module{\n                display: flex;\n                gap: 10px;\n            }\n\n            .ProductTraining_Tutorial_TutorialShooting {\n                width: auto;\n                padding: 10px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 600;\n                font-size: 14px;\n                border: none;\n                color: #FFFFFF;\n            }\n\n            .ProductTraining_TutorialShooting {\n                width: 16%;\n                height: 40px;\n                background: #0C3688;\n                border-radius: 8px 8px 8px 8px;\n                color: #ffff;\n                border: none;\n                font-family: \"Poppins\";\n                font-style: normal;\n                font-weight: 600;\n                font-size: 15px;\n            }\n\n            .ProductTraining_Modules {\n                width: auto;\n                padding: 10px;\n                background: #E5F0FF;\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 15px;\n                color: rgba(12, 54, 136, 1);\n                border: none;\n            }\n\n            .ProductTraining_ModulesTutorialShooting {\n                width: auto;\n                padding: 10px;\n                background: #E5F0FF;\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 15px;\n                color: rgba(12, 54, 136, 1);\n                border: none;\n            }\n\n            .ProductTraining_AddTutorial {\n                width: auto;\n                padding: 10px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 15px;\n                color: #FFFFFF;\n                border: none;\n                font-family: 'Poppins';\n                font-style: normal;\n            }\n        }\n    }\n\n    .pgmlist_buttons {\n        display: flex;\n        width: 96%;\n        margin: 1rem;\n        gap: 1rem;\n        border-bottom: 1px solid #C1C6D0;\n\n    }\n\n    .dealers_text {\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 1.25rem;\n        color: #10132e;\n\n    }\n\n    .dealers_button {\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        border-radius: 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 1rem;\n        color: #ffffff;\n        border: none;\n        height: 2.5rem;\n        cursor: pointer;\n        padding: 1rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .Pgmlist_pending {\n        width: 15%;\n        height: 40px;\n        left: 299px;\n        top: 122px;\n        background: #0C3688;\n        border-radius: 8px 8px 0px 0px;\n        font-family: 'Poppins';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        border: none;\n        color: #FFFFFF;\n    }\n\n    .pgmlist_Approved {\n        width: 15%;\n        height: 40px;\n        background: #E5F0FF;\n        border-radius: 8px 8px 0px 0px;\n        font-family: 'Poppins';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 15px;\n        color: #7C87A1;\n        border: none;\n    }\n\n    .pgmlist_Add {\n        width: 15%;\n        height: 40px;\n        background: #E5F0FF;\n        border-radius: 8px 8px 0px 0px;\n        font-family: 'Poppins';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 15px;\n        color: #7C87A1;\n        border: none;\n\n    }\n\n    .input-wrapper {\n        position: relative;\n    }\n\n    .input_search {\n        border: 1px solid gray;\n        border-radius: 6px;\n        position: relative;\n        width: 92%;\n        height: 2.5rem;\n        margin: 10px;\n        line-height: 6ex;\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        color: #10132E;\n        padding: 0rem 0.5rem;\n    }\n\n    label {\n        position: absolute;\n        top: 0.2ex;\n        z-index: 1;\n        left: 2em;\n        background-color: white;\n        padding: 0 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #0c3688;\n    }\n\n    .partscatainersorders {\n        display: flex;\n        margin: 1rem;\n        width: 100%;\n        gap: 2.4rem;\n    }\n\n    .partscatainersorders_s {\n        display: flex;\n\n\n    }\n\n    .AddpartsbulkAddpartsbulk {\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 5px;\n        border: none;\n        border-radius: 5px;\n        color: #ffffff;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n\n    }\n\n    .AddpartsbulkAddpartsbulk_s {\n        background: #E4ECF7;\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 5px;\n        border: none;\n        border-radius: 5px;\n        color: #0C3688;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n    }\n\n    .select-wrapper {\n        position: relative;\n        display: block;\n    }\n\n    select {\n        border: 1px solid gray;\n        border-radius: 6px;\n        position: relative;\n        margin: 10px;\n        line-height: 6ex;\n        width: 94%;\n        height: 2.5rem;\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        color: #10132E;\n        padding: 0rem 0.5rem;\n    }\n\n    ::placeholder {\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        color: #10132E;\n        padding: 0rem 0.5rem;\n    }\n\n    .productTrainingdropdown_textfield {\n        display: flex;\n        justify-content: space-between;\n        width: 96%;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 6px;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 6px;\n        margin: 1rem;\n        padding: 0.6rem;\n    }\n\n    .productTrainingPanel_checkbox {\n        display: flex;\n        justify-content: space-between;\n        width: 96%;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 0px;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        /* border-radius: 6px; */\n        margin: 0rem 1rem 0rem 1rem;\n        padding: 0.6rem;\n        position: relative;\n        /* bottom: -1rem; */\n        top: 1rem;\n    }\n\n    .btn_search_module{\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        color: #ffffff;\n        width: 20%;\n        height: 2.5rem;\n        text-align: center;\n        justify-content: center;\n        border: none;\n        margin: 0.6rem 1rem;\n    }\n\n    .btn_search_module:disabled{\n        background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n    }\n\n    .button_search {\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        color: #ffffff;\n        width: 40%;\n        height: 2.5rem;\n        text-align: center;\n        justify-content: center;\n        border: none;\n        margin: 0.6rem 1rem;\n    }\n\n    .button_search:disabled{\n        background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n    }\n\n    .button_div {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .tabledata-product {\n        display: flex;\n        width: 96%;\n        margin: 1rem 1rem;\n        overflow: auto;\n    }\n\n    .table {\n        border-collapse: collapse;\n        width: 100%;\n        background: #ffffff;\n        border: 0.5px solid #999797;\n        overflow: auto;\n    }\n   \n    .tablesth {\n        color: white;\n        text-align: left;\n        padding: 14px 12px;\n        background-color: #f5f5f5;\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        background: #0c3688;\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 5px -2px 0px 0px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        color: #ffffff;\n    }\n\n    .tabletd {\n        padding: 14px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #070707;\n        border-top: 0.5px solid #999797;\n        width: 18%;\n        white-space: break-spaces !important;\n        word-break: break-all;\n    }\n    .tabletddesc{\n        text-align: left;\n        padding: 14px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #070707;\n        border-top: 0.5px solid #999797;\n        word-wrap: break-word !important;\n    }\n    .truncated-description {\n        max-width: 8rem !important;\n        white-space: nowrap !important;\n        overflow: hidden !important;\n        text-overflow: ellipsis !important;\n        word-wrap: break-word !important;\n    }\n    .tabletd_view {\n        text-align: left;\n        padding: 22px 5px;\n        text-align: left;\n        padding: 14px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        text-decoration-line: underline;\n        color: #0c3688;\n        border-top: 0.5px solid #999797;\n        cursor: pointer;\n\n    }\n\n    .footer_div {\n        margin-top: 2rem;\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .header_border {\n        background: #C0C8DA;\n        height: 2.4rem;\n        border: 1px solid #C0C8DA;\n    }\n\n    .header_border>img {\n        margin: 0.9rem 1rem;\n    }\n\n    .header_border>span {\n\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n        letter-spacing: -0.28px;\n        margin: 0.7rem 1rem;\n    }\n\n    .productTrainingdropdown_div {\n        width: 100%;\n    }\n    .productTrainingdropdown_module{\n        width: 32%;\n    }\n    .productTrainingdropdown_search{\n        width: 70%;\n    }\n\n    .footer-panel {\n        height: 40px;\n        background-color: rgba(229, 240, 255, 1);\n        display: flex;\n        width: 96%;\n        margin: 1rem;\n        justify-content: center;\n        align-items: center;\n\n    }\n\n    .modal-content {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        width: 782px !important;\n    }\n\n    .pdf-text {\n        font-size: 12px;\n        font-weight: 400;\n        font-family: \"Nunito\";\n        margin: 0px;\n        padding: 3px;\n    }\n}\n\n@media screen and (max-width:480px) {\n    .ProductTraining_containers .ProductTraining_container {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n        flex-direction: column;\n    }\n    .ProductTraining_containers .ProductTrainingcontent {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 84vh;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons {\n        display: flex;\n        width: 95%;\n        margin: 1rem;\n        gap: 1rem;\n        flex-wrap: wrap;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_ModulesTutorialShooting {\n        width: auto;\n        height: 40px;\n        background: #E5F0FF;\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 15px;\n        color: rgb(12, 54, 136);\n        border: none;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial {\n        /* width: 15%; */\n        height: 40px;\n        left: 299px;\n        top: 122px;\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        border: none;\n        color: #FFFFFF;\n    }.ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial {\n         width: auto !important;\n        height: 40px;\n        left: 299px;\n        top: 122px;\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        border: none;\n        color: #FFFFFF;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_AddTutorial {\n        width: auto;\n        height: 40px;\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 15px;\n        color: #FFFFFF;\n        border: none;\n        font-family: \"Poppins\";\n        font-style: normal;\n        margin-left: 45%;\n    }\n    .ProductTraining_containers .productTrainingdropdown_textfield {\n        display: flex;\n        justify-content: space-between;\n        width: 96%;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 6px;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 6px;\n        margin: 1rem;\n        padding: 0.6rem;\n        flex-wrap: wrap;\n    }\n    .ProductTraining_containers .input_search {\n        border: 1px solid gray;\n        border-radius: 6px;\n        position: relative;\n        width: 64%;\n        height: 2.3rem;\n        margin: 10px;\n        line-height: 6ex;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        color: #10132E;\n        padding: 0rem 0.5rem;\n    }\n    .ProductTraining_containers .productTrainingdropdown_module {\n        width: 68%;\n    }\n    .tabledata {\n        overflow-x: scroll !important;\n    }\n    .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Tutorial_TutorialShooting {\n        width: auto !important;\n        height: 40px;\n        left: 299px;\n        top: 122px;\n        background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        border: none;\n        color: #FFFFFF;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_Modules {\n        width: auto !important;\n        height: 40px;\n        background: #E5F0FF;\n        border-radius: 8px 8px 8px 8px;\n        font-family: \"Poppins\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 15px;\n        color: rgb(12, 54, 136);\n        border: none;\n    }\n    .ProductTraining_containers .productTrainingPanel_checkbox {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        width: 96%;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        border-radius: 0px;\n        background: #ffffff;\n        border: 1px solid #c1c6d0;\n        margin: 0rem 1rem 0rem 1rem;\n        padding: 0.6rem;\n        position: relative;\n        top: 1rem;\n    }\n    .ProductTraining_containers .tabledata-product {\n    display: flex;\n    width: 96%;\n    margin: 1rem 1rem;\n    overflow-x: scroll;\n}   \n}\n\n@media screen and (max-width:480px) {\n    .ProductTraining_AddTutorial{\n        margin-left: 0 !important;\n    }\n}\n\n@media screen and (max-width:768px) {\n    .ProductTraining_container{\n        flex-direction: column;\n    }\n    .ProductTrainingcontent{\n        width: 100% !important;\n    }\n    .ProductTraining_containers .ProductTraining_buttons_container .ProductTraining_buttons .ProductTraining_ModulesTutorialShooting{\n        font-size: 12px;\n    }\n    .ProductTraining_containers label{\n        font-size: 12px;\n    }\n}\n\n@media screen and (min-width:481px) and (max-width:1100px) {\n    .ProductTraining_Tutorial_TutorialShooting{\n        font-size: 11px !important;\n    }\n    .ProductTraining_Modules{\n        font-size: 11px !important;\n    }\n    .ProductTraining_AddTutorial{\n        font-size: 11px !important;\n    }\n}\n\n@media screen and (min-width:481px) and (max-width:1024px) {\n    .ProductTraining_containers .checkbox_contain{\n        gap: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
